import { Dispatch } from "redux"
import { HistoryAction, HistoryActionType } from "../types/manyTargetCampaignsHistory"
import campaignApi from "../../api/campaignApi"
import { IDateRange } from "../../../../types/filter"

const fetchHistory = (dateRange: IDateRange) => {
  return async (dispatch: Dispatch<HistoryAction>) => {
    try {
      dispatch({ type: HistoryActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS })
      const sponsoredProductData = await campaignApi.getHistory(dateRange)

      dispatch({
        type: HistoryActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_SUCCESS,
        payload: sponsoredProductData.data.targetChangesTasks ?? [],
      })
    } catch (e) {
      dispatch({
        type: HistoryActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_ERROR,
        payload: "Failed to load SP history. Please try again.",
      })
    }
  }
}

export default {
  fetchHistory,
}
